//Get Reducer Call--->
export const getProductRequest = (page: number, size: number, search: string, order_by: number) => ({
  type: 'GET_PRODUCT_REQUEST',
  payload: { page, size, search, order_by },
});

export const getProductSuccess = (data: any) => ({
  type: 'GET_PRODUCT_SUCCESS',
  payload: { data },
});

export const getProductFailure = (data: string) => ({
  type: 'GET_PRODUCT_FAILURE',
  payload: { data },
});

export const resetGetProduct = () => ({
  type: 'RESET_GET_PRODUCT',
});

//Create Reducer Call--->
export const createProductRequest = (data: any) => ({
  type: 'CREATE_PRODUCT_REQUEST',
  payload: data,
});

export const createProductSuccess = (data: any) => ({
  type: 'CREATE_PRODUCT_SUCCESS',
  payload: { data },
});

export const createProductFailure = (data: string) => ({
  type: 'CREATE_PRODUCT_FAILURE',
  payload: { data },
});

export const resetCreateProduct = () => ({
  type: 'RESET_CREATE_PRODUCT',
});

//Update Reducer Call--->
export const updateProductRequest = (data: any, id: string) => ({
  type: 'UPDATE_PRODUCT_REQUEST',
  payload: { data, id },
});

export const updateProductSuccess = (data: any) => ({
  type: 'UPDATE_PRODUCT_SUCCESS',
  payload: { data },
});

export const updateProductFailure = (data: string) => ({
  type: 'UPDATE_PRODUCT_FAILURE',
  payload: { data },
});

export const resetUpdateProduct = () => ({
  type: 'RESET_UPDATE_PRODUCT',
});
//Delete Reducer Call--->
export const deleteProductRequest = (id: string) => ({
  type: 'DELETE_PRODUCT_REQUEST',
  payload: { id },
});

export const deleteProductSuccess = (data: any) => ({
  type: 'DELETE_PRODUCT_SUCCESS',
  payload: { data },
});

export const deleteProductFailure = (data: string) => ({
  type: 'DELETE_PRODUCT_FAILURE',
  payload: { data },
});

export const resetDeleteProduct = () => ({
  type: 'RESET_DELETE_PRODUCT',
});
